import React from 'react';
import PortalSignInFlow from '../components/PortalSignInFlow';

export default function OpsLogin() {
  return (
    <PortalSignInFlow
      title="Ops sign in"
      subtitle="Operations portal — sign in with OTP, password, or Google for provisioned ops emails."
      authKind="ops"
      redirectPrefix="/ops"
      defaultRedirect="/ops"
      lookupPath="/api/portal/ops/lookup"
      passwordPath="/api/portal/ops/login"
      sendOtpPath="/api/portal/ops/send-otp"
      googlePath="/api/portal/ops/google"
      otpPagePath="/ops/login/otp"
      notProvisionedError="This email is not authorized for ops access. Ask an admin to add you in Ops Users."
      googleDeniedError="Google Sign-In is only available for provisioned ops emails. Use OTP or password, or ask an admin."
    />
  );
}
